import { TooltipProvider } from '../../ui/Tooltip';
import { UpdateSnackbar } from '../../components/UpdateSnackbar';

export const PanelLayout = ({ children }) => (
  <TooltipProvider delayDuration={250}>
    <main className="h-dvh min-h-0 w-full overflow-hidden bg-dusq-canvas">{children}</main>
    <UpdateSnackbar />
  </TooltipProvider>
);
